import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';

import {
  NavBar,
  HelperViewContextual,
  Heading,
  BaseText,
  Row,
  InitialAvatarIcon,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { PasswordModal } from '../PasswordModal';

import { IMarginAllocation } from '@/modules/trade/services/margin-allocation';
import { EMarginAllocationSteps } from '@/modules/trade/views/MarginAllocation/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'TraderShield',
  setup(__props) {

const handleTraderShield = inject('handleTraderShield', () => ({}));
const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));

const dataForm = inject('dataForm') as Ref<{ isUpdatingTraderShield: boolean }>;
const marginAllocation = inject('marginAllocation') as Ref<IMarginAllocation>;

const isPasswordModalOpen = ref(false);

const isTraderShieldEnabled = computed(() => {
  return marginAllocation.value.isTraderShieldEnabled;
});

const buttonLabel = computed(() => {
  return isTraderShieldEnabled.value
    ? 'Desativar Trader Shield'
    : 'Ativar Trader Shield';
});

const details = computed(() => {
  return [
    {
      title: 'Ative o Trader Shield',
      subtitle:
        'Proteja seu patrimônio de perdas significativas na primeira zeragem.',
      icon: 'BC0030'
    },
    {
      title: 'Bloqueie seus Limites Day Trade',
      subtitle:
        'Seus limites day trade não podem ser editados enquanto o mercado estiver aberto.',
      icon: 'EF0031'
    },
    {
      title: 'Desative o Trader Shield com segurança',
      subtitle:
        'Desative o Trader Shield com a sua senha, se estiver ciente dos riscos ao seu patrimônio.',
      icon: 'BC0010'
    }
  ];
});

function handleClick() {
  if (isTraderShieldEnabled.value) {
    isPasswordModalOpen.value = true;
    return;
  }

  handleTraderShield();
}

function confirmPassword() {
  isPasswordModalOpen.value = false;

  handleTraderShield();
}

function handleBack() {
  changeStep(EMarginAllocationSteps.DAY_TRADE_LIMITS);
}

return { __sfc: true,handleTraderShield, changeStep, dataForm, marginAllocation, isPasswordModalOpen, isTraderShieldEnabled, buttonLabel, details, handleClick, confirmPassword, handleBack, NavBar, HelperViewContextual, Heading, BaseText, Row, InitialAvatarIcon, ButtonContainer, ButtonPrimary, BackButton, PasswordModal }
}

})